export default "__VITE_ASSET__e38af262__"